export const MIN_MODAL_HEIGHT = 200;
export const MIN_MODAL_WIDTH = 620;
export const HEADER_FOOTER_HEIGHT = 44;
